module.exports = __webpack_public_path__ + "static/media/fingerPrintIcon.eeb02dee.svg";